import { useState } from "react";
import { Grid, Tabs } from "@mantine/core";
import { TextTab } from "../../model/TextTab";
import RolesTable from "./RolesTable";

const RolesView = () => {
  const [activeTab, setActiveTab] = useState<string | null>("Danh sách vai trò");

  let headertext: TextTab[] = [
    { text: "Danh sách vai trò", content: RolesTable },
  ];

  return (
    <Grid>
      <Grid.Col span={{ base: 12 }}>
        <Tabs value={activeTab} onChange={setActiveTab} keepMounted={false}>
          <Tabs.List>
            {headertext.map((item) => (
              <Tabs.Tab value={item.text} key={item.text}>
                {item.text}
              </Tabs.Tab>
            ))}
          </Tabs.List>

          {headertext.map((item) => (
            <Tabs.Panel value={item.text} key={item.text} pt="xs">
              <item.content />
            </Tabs.Panel>
          ))}
        </Tabs>
      </Grid.Col>
    </Grid>
  );
};
export default RolesView;
